import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { styled, css, up } from '@smooth-ui/core-sc';
import { Link } from 'react-router-dom';

const PromoBanner = props => {
  const [isMobile, setIsMobile] = useState(false);

  const handleResize = () => {
    if (window.innerWidth < 768 && !isMobile) {
      setIsMobile(true);
    } else if (window.innerWidth >= 768 && isMobile) {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize, false);
    return () => {
      window.removeEventListener('resize', handleResize, false);
    };
  });

  handleResize();

  const PromoContainer = styled.div`
    margin: 0 auto;
    height: 250px;
    ${up(
      'md',
      css`
        height: 339px;
      `
    )}
    width: 100%;
    ${props =>
      props.bgImage ? `background-image: url(${props.bgImage});` : null};
    background-position: center center;
    a {
      display: block;
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      img {
        padding: 2%;
        margin: 0 auto;
        max-height: 240px;
        ${up(
          'md',
          css`
            max-width: 1168px;
            width: 96%;
          `
        )}
      }
    }
  `;

  return (
    <PromoContainer {...props}>
      <Link to="/promotions">
        {isMobile && props.mobileImage ? (
          <img src={props.mobileImage} alt={props.altText} />
        ) : (
          <img src={props.image} alt={props.altText} />
        )}
      </Link>
    </PromoContainer>
  );
};

PromoBanner.propTypes = {
  image: PropTypes.string.isRequired,
  mobileImage: PropTypes.string,
  bgImage: PropTypes.string.isRequired,
  altText: PropTypes.string.isRequired,
};

PromoBanner.defaultProps = {
  mobileImage: undefined,
};

export default PromoBanner;
